import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { UsersService } from 'src/app/pages/users/users.service';

@Component({
  selector: 'app-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.css'],
})
export class BreadCrumbComponent implements OnInit {
  breadcrumbs: Breadcrumb[] = [{ label: 'Inicio', url: '/home' }];
  private businessSubscription: Subscription = new Subscription();
  businessDefined: boolean = false;
  userBusiness: string = '';
  businessTransform: any = {
    lubricants: 'Lubricantes',
    nocore: 'no Core',
    fuels: 'Combustibles',
    foreign: 'Externos',
  };
  activeUserInBusinessSelectorSubcription: Subscription = new Subscription();
  activeUserInBusinessSelector: boolean = true;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private usersService: UsersService
  ) {}
  ngOnInit(): void {
    this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
    this.activeUserInBusinessSelectorSubcription =
      this.usersService.inBusinessSelector.subscribe((value: boolean) => {
        this.activeUserInBusinessSelector = value;
        console.log('user businneesss', this.userBusiness);
        if (this.businessDefined && !this.activeUserInBusinessSelector) {
          this.breadcrumbs[1] = {
            label: this.translateBusiness(this.userBusiness),
            url: '/home',
          };
        }
      });
    // Escuchar cambios de ruta
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root);
      });

    this.businessSubscription = this.usersService.business.subscribe(
      (business: string): void => {
        console.log('busines!!!', business);
        this.userBusiness = business;
        this.businessDefined = business !== '';
      }
    );
  }
  private createBreadcrumbs(
    route: ActivatedRoute,
    url: string = ''
  ): Breadcrumb[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return this.breadcrumbs;
    }
    console.log('children', children);
    for (const child of children) {
      // Ignorar outlets que no sean el principal
      if (child.outlet !== 'primary') {
        continue;
      }

      // 1. Construir la URL acumulada
      const routeSegments = child.snapshot.url.map((segment) => segment.path);
      if (routeSegments.length > 0) {
        url += `/${routeSegments.join('/')}`;
      }

      // 2. Determinar la Etiqueta (Label)
      let label = child.snapshot.data['breadcrumb'];
      let position = child.snapshot.data['position'];
      // Lógica Dinámica: Si no hay label fijo, usar el segmento de la URL (ej: Lubricants)
      // if (!label && routeSegments.length > 0) {
      //   const segmentPath = routeSegments[routeSegments.length - 1];
      //   label = this.capitalize(segmentPath);
      // }

      // 3. VALIDACIÓN DE DUPLICADOS (La parte que faltaba)
      const lastBreadcrumb = this.breadcrumbs[this.breadcrumbs.length - 1];
      const isUrlDuplicate = lastBreadcrumb && lastBreadcrumb.url === url;
      console.log(this.breadcrumbs);
      // Solo procedemos si tenemos una etiqueta
      if (label) {
        if (isUrlDuplicate) {
          // CASO DUPLICADO (path: ''):
          // No agregamos uno nuevo. Opcionalmente actualizamos el nombre si el hijo es más específico.
          // En tu caso, preferimos quedarnos con el nombre del padre ('Tanques'), así que no hacemos nada
          // o sobrescribimos solo si es necesario:
          // lastBreadcrumb.label = label;
        } else {
          // CASO NORMAL: URL nueva, agregamos el breadcrumb
          this.breadcrumbs[position] = { label, url };
        }
      }

      console.log(this.breadcrumbs);
      return this.createBreadcrumbs(child, url);
    }
    console.log(this.breadcrumbs);
    return this.breadcrumbs;
  }

  private capitalize(s: string): string {
    if (!s) return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  private translateBusiness(business: string): string {
    let result = '';
    result = this.businessTransform[business];
    return result;
  }
}
export interface Breadcrumb {
  label: string;
  url: string;
}
